import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { uri } from "../../../help/Api";

import HeaderD from "./A4/HeaderD"
import LoadingPage from "../../../services/LoadingPage";
import BodyInv from "./A4/BodyInv";

import UnderHeader from "./A4/UnderHeader"
import UnderHeaderT from "./A4/UnderHeaderT";
import * as _ from "lodash";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { ButtonBase, Grid, Typography } from "@material-ui/core";
import FooterCM from "./A4/FooterCM";
import { sto } from "../../../Context/InshData";
import FooterM from "../maintaince/A4/FooterM";
import { useInvAF } from "../../../St/Reviews/UseStyle";
import BodyCom from "../invCompanyTow/A4/BodyCom";
import UnderHeaderCom from "../invCompanyTow/A4/UnderHeaderCom";
import HeaderCom from "../invCompanyTow/A4/HeaderCom";
import UnderHeaderComTow from "../invCompanyTow/A4/UnderHeaderComTow";

function BillPage(props) {
  // const { locInv, found, sta, inv, chunk } = props;
  const { locInv, found, sta, inv, chunk, isFirst, isLast, sum } = props;
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};
  const clas = useInvAF();

  return (
    <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_page }}>

      <Fragment>
        {premiApp.billTemplate !== 9 ? (
          <Grid xs={12} item
            style={{ ...stElemnt.AF.Reviws.pdf_bodyCom }}
          >
            <HeaderD locInv={locInv} foundData={found} sta={sta} />
            {premiApp.billTemplate === 27 ?
              (<UnderHeaderComTow found={found} inv={inv} sta={sta} />) :
              (<UnderHeaderT found={found} inv={inv} sta={sta} />)}

            <UnderHeader found={found} inv={inv} sta={sta} locInv={locInv} />
            <BodyInv
              data={chunk ?? []}
              isFullPage={!isFirst ? true : false}
              isLast={isLast}
              inv={inv}
              sta={sta}
              locInv={locInv}
              found={found}

            />
          </Grid>
        ) : (
          <Grid xs={12} item
            style={{ ...stElemnt.AF.Reviws.pdf_bodyComany }}
          >
            <HeaderD locInv={locInv} foundData={found} sta={sta} />
            <UnderHeaderT found={found} inv={inv} sta={sta} />
            <UnderHeader found={found} inv={inv} sta={sta} locInv={locInv} />
            <BodyInv
              data={chunk ?? []}
              isFullPage={!isFirst ? true : false}
              isLast={isLast}
              inv={inv}
              sta={sta}
              locInv={locInv}
              found={found}

            />
          </Grid>
        )}

        {found.footer_img != null ? (
          (
            <Grid item xs={12} justifyContent="center" style={{ minWidth: "20cm", maxWidth: "20cm", minHeight: "3.6cm", maxHeight: "3.6cm", paddingBottom: "0.2cm", paddingTop: "0.1cm" }}>
              <div>
                <ButtonBase>
                  {" "}
                  <img
                    src={`data:image/jpeg;base64,${found.footer_img}`}
                    className={clas.headerImg}
                    alt={found.nameA}
                  />{" "}
                </ButtonBase>
              </div>
            </Grid>
          )
        )
          : premiApp.billTemplate !== 9 ? (

            <Grid xs={12} item style={{ maxHeight: "3.8cm", minHeight: "3.8cm" }}>
              <FooterCM found={found} inv={inv} data={sta ?? {}} />
            </Grid>

          ) : (
            <Grid xs={12} item style={{ maxHeight: "3.8cm", minHeight: "3.8cm" }}>
              <FooterM found={found} inv={inv} data={sta ?? {}} />
            </Grid>

          )}

      </Fragment>
    </Grid>
  );
}
function BillPageInv2(props) {
  // const { locInv, found, sta, inv, chunk } = props;
  const { locInv, found, sta, inv, chunk, isFirst, isLast, sum } = props;
  const clas = useInvAF();
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};

  return (
    <Grid item container style={{ ...stElemnt.AF.Reviws.pdf_pageCar }}>
      <Fragment>
        <Grid xs={12} item
        >
          {premiApp.billTemplate === 25 || premiApp.billTemplate === 26 ?
            (
              <>
                <HeaderCom found={found} sta={sta} inv={inv} locInv={locInv} />
                <UnderHeaderCom found={found} inv={inv} sta={sta} locInv={locInv} />
                <BodyCom
                  data={chunk ?? []}
                  isFullPage={!isFirst ? true : false}
                  isLast={isLast}
                  inv={inv}
                  sta={sta}
                  locInv={locInv}
                  found={found}
                />
              </>

            ) :
            (
              <>
                <HeaderD locInv={locInv} foundData={found} sta={sta} />
                <UnderHeaderT found={found} inv={inv} sta={sta} />
                <UnderHeader found={found} inv={inv} sta={sta} locInv={locInv} />
                <BodyInv
                  data={chunk ?? []}
                  isFullPage={!isFirst ? true : false}
                  isLast={isLast}
                  inv={inv}
                  sta={sta}
                  locInv={locInv}
                  found={found}
                />
                <Grid xs={12} item style={{ maxHeight: "3.8cm", minHeight: "3.8cm" }}>
                  <FooterCM found={found} inv={inv} data={sta ?? {}} />
                </Grid>
              </>
            )}
        </Grid>

        {/* <Grid xs={12} item style={{ maxHeight: "3.8cm", minHeight: "3.8cm" }}>
          <FooterCM found={found} inv={inv} data={sta ?? {}} />
        </Grid> */}
      </Fragment>
    </Grid>
  );
}
function InvContainer(props) {
  const locInv = JSON.parse(localStorage.getItem("datainv")) || {};
  const [found, setFound] = useState({});
  const [sta, setSta] = useState({});
  const [inv, setInv] = useState({});
  const [loading, setLoading] = useState(true);
  const [chunks, setChunks] = useState([]);
  const [chunks2, setChunks2] = useState([]);
  const premiApp = JSON.parse(localStorage.getItem("premiApp")) || {};


  const getInfo = async () => {
    // alert('getInfo')
    const tb = {
      GetFoundation: true,
      Rpt_Inv: true,
      wait: true,
      SettInvsApp: true,
      parms: {
        lprocid: locInv.proc_id,
        ibranchid: sto.branchi,
        iFoundid: 1,
        branch: sto.branchi,
        sProcTypeInvProc: locInv.ProcTypeInvProc,
      },
      autos: {},
    };
    console.log(tb);
    await axios
      .post(`${uri}Res`, tb)
      .then((res) => {
        setSta({ info: res.data.RptInv, tot: res.data.infoBill, StngIA: res.data.SettInvsApp });
        console.log("res.data.RptInv");
        const data2 = res.data.RptInv.map((row, i) => {
          return {
            ...row,
            no: i + 1,
          };
        });
        setChunks(_.chunk(data2, 8));
        setChunks2(data2);

        setFound(res.data.Found);
      })
      .catch((error) => {
        console.log("catch");
      });
  };
  const getInv = async () => {
    axios
      .get(uri + `InvForFatora?proc_id=${locInv.proc_id}`)
      .then((res) => {
        console.log("the inve for fatoora", res.data);
        setInv(res.data);
      })
      .catch((error) => { });
  };
  useEffect(() => {
    setTimeout(async () => {
      await getInfo();
      await getInv();
      setLoading(false);
      // onUnmountComplete();
    }, 0);
  }, []);

  if (!found || !sta || loading) return <LoadingPage />;

  return (
    <Typography component="div" style={stElemnt.AF.Reviws.ReviwsJard}>
      <Typography component="div" >
        {chunks.map((page, i) => {

          return (
            <>
              {premiApp.billTemplate === 21 || premiApp.billTemplate === 22
                || premiApp.billTemplate === 25 || premiApp.billTemplate === 24 || premiApp.billTemplate === 26 ? (
                <BillPageInv2
                  {...{
                    locInv,
                    found,
                    sta,
                    inv,
                    chunk: page,
                    isFirst: i == 0,
                    isLast: i == chunks.length - 1,
                  }}
                />
              ) :
                (
                  <BillPage
                    {...{
                      locInv,
                      found,
                      sta,
                      inv,
                      chunk: page,
                      isFirst: i == 0,
                      isLast: i == chunks.length - 1,
                    }}
                  />
                )}
            </>
          );
        })}
      </Typography>
    </Typography>
  );
}
export default InvContainer;
